export function formatXAF(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("fr-FR", {
    style: "decimal",
    maximumFractionDigits: 0,
  }).format(n) + " FCFA";
}

export function formatDate(iso, lang = "fr") {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US", {
      year: "numeric", month: "short", day: "2-digit",
    });
  } catch { return ""; }
}
